/// <amd-module name="typeahead/features/AkamaiCurrentLocation" />
/// <reference path="../../typings/typeahead/IPageLoadHandler.d.ts"/>

import {Experiment} from "typeahead/core/Experiment";
import {IFlightOriginSuggestion} from "typeahead/core/FlightOriginSuggestion";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {FlightOriginPopulationMessage} from "typeahead/core/message/FlightOriginPopulationMessage";
import {FormLoadedMessage} from "typeahead/core/message/FormLoadedMessage";
import {SuggestionAutoSelectedMessage} from "typeahead/core/message/SuggestionAutoSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {prefetchInstance} from "typeahead/core/plugins/CompositePageLoadHandler";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IActiveSearch} from "typeahead/core/plugins/PrefetchLoader";
import * as SearchParametersUpdater from "typeahead/core/SearchParametersUpdater";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import * as SuggestionFactory from "typeahead/core/SuggestionFactory";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: StripingConfiguration.IStripingConfiguration[] = [
    {
        clients: ["Homepage", "FlightsLandingPage"],
        experiment: {
            id: 25022,
            name: "ESS_Akamai_Current_Location_Flight",
        },
        tabs: ["flight"],
    },
];

export class AkamaiCurrentLocation implements IExperimentalFeature, IPageLoadHandler {

    public SELECTOR: string = "input[data-provide='utypeahead'][data-lob='FLIGHTS'][id^='flight-origin-']";

    public handlePageLoad(options: any, context: IContext): void {
        TypeaheadMessage.subscribe(FormLoadedMessage.getTopic(), (topic: string, message: FormLoadedMessage) => {
            context.tab = message.getTab();
            prefetchInstance.getPrefetchFlightOriginSuggestion().done((result: IFlightOriginSuggestion) => {
                prefetchInstance.getPrefetchActiveSearch().done((activeSearchData: IActiveSearch) => {
                    this.populateFlightOriginIfApplicable(activeSearchData, context, result);
                });
            });
        });
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    private populateFlightOriginIfApplicable(activeSearchData: IActiveSearch, context: IContext,
                                             result: IFlightOriginSuggestion) {
        if (this.isNotActiveSearch(activeSearchData)) {
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                if (result.suggestion) {
                    let flightSuggestion = SuggestionFactory.createSuggestion(result.suggestion);
                    let airportName = flightSuggestion.getLastSearchName().orElse("");
                    let $input = $(this.SELECTOR);
                    let latLong: string[] = TypeaheadUtils.getUserLocation().split("|");
                    if (airportName && $input && $input.length > 0) {
                        $input.val(airportName);
                        SearchParametersUpdater.updateForSuggestion(airportName, flightSuggestion, $input.data(),
                            $input.attr("id"));
                        TypeaheadMessage.publish(
                            new FlightOriginPopulationMessage(airportName, latLong[0], latLong[1]));
                        TypeaheadMessage.publish(
                            new SuggestionAutoSelectedMessage(flightSuggestion, $input.attr("id")));
                    }
                }
            }
        }
    }

    private isNotActiveSearch(activeSearchData: IActiveSearch) {
        return activeSearchData.hasOwnProperty("AIR") && activeSearchData.AIR !== true;
    }
}
